import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { ecommerceBaseUrl } from "network";

export const shopSubCat = createApi({
    reducerPath: "shopSubCat",
    baseQuery: fetchBaseQuery({
        baseUrl: ecommerceBaseUrl,
        credentials: "include",
        prepareHeaders: (headers, { getState }) => {
            const state = getState();
            const token = state.auth?.token;
            if (token) {
                console.log('token', token);
                headers.set("authorization", `Bearer ${token}`);
            } else {
                console.warn("Token not found in state.auth");
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        // ✅ Get All Categories
        getShopSubCategories: builder.query({
            query: ({ page = 1, limit = 10, search = "", category = "" }) => ({
                url: `/subCategory?page=${page}&limit=${limit}&search=${search}&category=${category}`,
                method: "GET",
            }),
            transformResponse: (response) => response,
        }),

        // ✅ Add New Category
        addShopSubCategory: builder.mutation({
            query: (body) => ({
                url: "/subCategory",
                method: "POST",
                body,
            }),
        }),

        // ✅ Update Existing Category
        updateShopSubCategory: builder.mutation({
            query: ({ id, body }) => ({
                url: `/subCategory/${id}`,
                method: "PUT",
                body,
            }),
        }),

        // ✅ Delete Category
        deleteShopSubCategory: builder.mutation({
            query: (id) => ({
                url: `/subCategory/${id}`,
                method: "DELETE",
            }),
        }),
    }),
});

export const {
    useGetShopSubCategoriesQuery,
    useAddShopSubCategoryMutation,
    useUpdateShopSubCategoryMutation,
    useDeleteShopSubCategoryMutation
} = shopSubCat;
